module.exports = function() {
  return new Worker(__webpack_public_path__ + "fd09a60e7898530a4ea9.worker.js");
};